module.exports = __webpack_public_path__ + "assets/44600676bca78b5a52a55b88c529c4b7.mp4";